import { useCallback, useMemo } from "react";

const defaultOptions: Intl.NumberFormatOptions = {
  style: "currency",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export const useFormatCurrency = (
  locale: string,
  options?: Intl.NumberFormatOptions,
) => {
  const getValueWithCurrency = useCallback(
    (value: string | number | null | undefined) => {
      if (value === null || value === undefined) return "";

      const numericValue = typeof value === "number" ? value : Number(value);

      if (Number.isNaN(numericValue)) return "";

      return new Intl.NumberFormat(locale, {
        ...defaultOptions,
        ...options,
      }).format(numericValue);
    },
    [locale, options],
  );

  const currency = useMemo(() => {
    if (!options?.currency) return null;

    return new Intl.NumberFormat(locale, { ...defaultOptions, ...options })
      .formatToParts(0)
      .find(({ type }) => type === "currency")?.value;
  }, [locale, options]);

  return [getValueWithCurrency, currency] as const;
};
